import { useState } from "react";
import { fetchRosterManagementReportCsv } from "../api/fetchRosterManagementReport/fetchRosterManagementReportCsvApi";
import { FetchRosterManagementReportParams } from "../api/fetchRosterManagementReport/types";
import { downloadFile } from "@/utils/downloadFile";

export function useDownloadRosterManagementReportCsv() {
  const [loading, setLoading] = useState(false);

  const downloadCsv = async (
    params: Omit<FetchRosterManagementReportParams, "page" | "pageSize"> = {},
  ) => {
    setLoading(true);
    try {
      const blob = await fetchRosterManagementReportCsv(params);
      const date = new Date().toISOString().split("T")[0];
      downloadFile(blob, `roster-management-report-${date}.csv`);
    } finally {
      setLoading(false);
    }
  };

  return { loading, downloadCsv };
}
